import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AOS from 'aos';
import 'aos/dist/aos.css';
import HeroImage from '../assets/landing.png';
import landing_bg from '../assets/landing_bg1.png';
import mobile_bg from '../assets/landing_bg_mob.png';

const LandingPage = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,  // Animation duration in ms
      once: true,      // Only animate once per element
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Eye Care Optical | Leading eyewear shop in Kigali | Best opticians in Kigali Rwanda</title>
        <meta name="description" content="Kids eyewear, Blue cut lenses & Contact lenses.Branded sunglasses, Stylish eyewear & Reliable service in Kigali Rwanda" />
        <meta name="keywords" content="Eyewear shop in Kigali, Eyewear Kigali, Prescription glasses Kigali, Best Optical shop Kigali, Sunglasses Kigali Rwanda, Contact lenses Kigali Rwanda, All kids eye glasses, Opticians in Kigali, Premium blue cut lenses, Branded sunglasses shops in Kigali, Ophthalmic frames" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://eyecarepractice.com" />
        <meta property="og:title" content="Eye Care Optical | Leading eyewear shop in Kigali | Best opticians in Kigali Rwanda" />
        <meta property="og:description" content="Kids eyewear, Blue cut lenses & Contact lenses.Branded sunglasses, Stylish eyewear & Reliable service in Kigali Rwanda" />
        <meta property="og:image" content="https://eyecarepractice.com/logo2.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Eye Care Optical | Leading eyewear shop in Kigali | Best opticians in Kigali Rwanda" />
        <meta name="twitter:description" content="Kids eyewear, Blue cut lenses & Contact lenses.Branded sunglasses, Stylish eyewear & Reliable service in Kigali Rwanda" />
        <meta name="twitter:image" content="https://eyecarepractice.com/logo2.png" />
      </Helmet>
      <div id="home" className="relative overflow-hidden flex items-center justify-center px-4 lg:px-24 pt-20 lg:pt-0">
      {/* ✅ Mobile Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-90 -z-10 block lg:hidden"
        style={{ backgroundImage: `url(${mobile_bg})` }}
      ></div>

      {/* ✅ Desktop Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-90 -z-10 hidden lg:block"
        style={{ backgroundImage: `url(${landing_bg})` }}
      ></div>

      {/* Content Container */}
      <div className="flex flex-col-reverse lg:flex-row items-center justify-between w-full max-w-7xl z-10">
        
        {/* Left Image Section */}
        <div className="w-full lg:w-1/2 flex justify-center mt-8 lg:mt-0">
          <img
            src={HeroImage}
            alt="Stylish woman with glasses"
            className="w-[90%] max-w-md"
          />
        </div>

        {/* Right Text Content */}
        <div className="w-full lg:w-1/2 text-center lg:text-left space-y-5">
          <div className="lg:text-left space-y-5">
            <h1 data-aos="fade-left" className="text-4xl lg:text-5xl font-manrope mt-8 lg:mt-0 font-extrabold text-[#3471B8] leading-tight">
              Where comfort<br />meets style!
            </h1>
            <p data-aos="fade-left" className="text-[#343434] font-manrope text-[16px] font-medium">
              Say goodbye to scratchy & dull glasses.<br />
              Discover stylish, comfortable, and durable eyewear here
            </p>
            <button  data-aos="fade-left" className="bg-gradient-to-br from-[#3471B8] to-[#173252] font-manrope text-white px-6 py-3 rounded-md hover:opacity-90 transition">
             Explore eyewears
            </button>
          </div>


          {/* ✅ White-to-transparent bottom gradient */}
          <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-white to-transparent z-0" />
        </div>
      </div>
    </div>
    </>
  );
};

export default LandingPage;
